import moment from "moment";

export default (data = moment()) => moment(data).seconds(0).format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);